import { render, staticRenderFns } from "./draggable.component.vue?vue&type=template&id=48c972d2&scoped=true&"
import script from "./draggable.component.vue?vue&type=script&lang=ts&"
export * from "./draggable.component.vue?vue&type=script&lang=ts&"
import style0 from "./draggable.component.vue?vue&type=style&index=0&id=48c972d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c972d2",
  null
  
)

export default component.exports